/* eslint-disable @angular-eslint/directive-selector */
import { Component, OnInit ,Directive,ElementRef, AfterViewInit,Input, Renderer2, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { PostLoginNavigationComponent } from '../../components/post-login-navigation.component';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { CodeInputComponent, CodeInputModule } from 'angular-code-input';
import { LoginContentContainerComponent } from '../../../../shared/components/login-content-container/login-content-container.component';
import { MatButton } from '@angular/material/button';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { LanguageSelectorComponent } from '../../../../shared/components/language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Directive({ selector: '[mfaarialabel]' })
export class MFAInputAriaLabelDirective implements AfterViewInit{  
  @Input()
  codeLength :number;
  constructor(private el:ElementRef, private renderer: Renderer2){  }
  ngAfterViewInit(){   
    const inputElements= this.el.nativeElement.querySelectorAll('input');    
    inputElements.forEach((input : HTMLInputElement,index : number) => {
      if(index < this.codeLength)
      this.renderer.setAttribute(input,'aria-label',`Enter digit ${index +1}`);         
    });  
  }
}
@Component({
    templateUrl: './mfa.component.html',
    styleUrls: ['./mfa.component.scss'],
    imports: [LoginContentContainerComponent, CodeInputModule, MFAInputAriaLabelDirective, MatButton, ButtonComponent, LanguageSelectorComponent, TranslateModule]
})
export class MfaComponent extends PostLoginNavigationComponent implements OnInit {

  @ViewChild('codeInput') codeInput !: CodeInputComponent;

  mfaToken: string;
  mfaCode: string;

  constructor(protected _authService: AuthService, _campaignService: CampaignService, customNavigationService: CustomNavigationService,
      _router: Router ) {

    super(_authService, _campaignService, customNavigationService);

    const pageState = _router.getCurrentNavigation()?.extras.state;
    this.mfaToken = pageState && pageState.mfaToken;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  verifyMfaCode() {
    this._authService.verifyMfaCode({mfaToken: this.mfaToken, code: this.mfaCode}).subscribe(
      authResponse => {
        this.navigateToPostLoginLoginDestinationPage(authResponse);
      },
      _ => {
        this.showError('mfa.error.verification_failed');
      }
    );
  }

  resendMfaCode() {
    this.codeInput.reset();
    this._authService.resendMfaCode(this.mfaToken).subscribe(
      (mfaToken) => {
        this.mfaToken = mfaToken;
        this.showSuccess('mfa.resend_code_success');
      },
      _error => {
        this.showError('mfa.error.resend_code_failed');
      }
    );
  }

  returnToSignIn() {
    this.customNavigationService.navigate(['/main']);
  }

  onCodeCompleted(code: string) {
    this.mfaCode = code;
    this.verifyMfaCode();
  }
}
